import React, { useContext } from 'react';
import { IModifiersContext, ModifiersContext } from '../../../modifiersState/modifiersContext';
import SearchField from 'components/SearchField/SearchField';

const Search: React.FC = () => {
	const { changeSearchString, searchString, modifiers } = useContext<IModifiersContext>(ModifiersContext);

	return (
		<SearchField
			onChangeSelectSearchString={changeSearchString}
			searchString={searchString}
			delay={modifiers.modifiersCount ? 800 : undefined}
		/>
	);
};

export default Search;
